var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeadphone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48,
    height: 48,
    x: 0,
    y: 0,
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31 23h-2v-5a13 13 0 0 0-26 0v5H1v-5a15 15 0 0 1 30 0z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.23 29H6a5 5 0 0 1-5-5v-2a5 5 0 0 1 5-5h1.23A1.8 1.8 0 0 1 9 18.8v8.4A1.8 1.8 0 0 1 7.23 29zM6 19a3 3 0 0 0-3 3v2a3 3 0 0 0 3 3h1v-8zM26 29h-1.2a1.8 1.8 0 0 1-1.8-1.8v-8.4a1.8 1.8 0 0 1 1.8-1.8H26a5 5 0 0 1 5 5v2a5 5 0 0 1-5 5zm-1-2h1a3 3 0 0 0 3-3v-2a3 3 0 0 0-3-3h-1z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadphone);
export default __webpack_public_path__ + "static/media/headphone.23b17a603d87566193c8de572aff6955.svg";
export { ForwardRef as ReactComponent };